<nav class="navbar">
  <div class="navbar__nav-region">
    @if (canScrollUp()) {
      <button
        type="button"
        class="navbar__scroll-btn"
        aria-label="Scroll navigation up"
        (click)="scrollNav(-1)"
      >
        <i class="fa-solid fa-chevron-up" aria-hidden="true"></i>
      </button>
    }
    <div #navScroll class="navbar__scroll" (scroll)="onNavScroll()">
      <ul>
        <li
          class="navbar__link"
          (focusout)="onHoverGroupFocusOut($event)"
          (keydown.escape)="onHoverGroupEscape($event)"
          tabindex="-1"
        >
          <div
            class="navbar__filing-trigger"
            (mouseenter)="showHoverMenu('home', $event.currentTarget)"
            (mouseleave)="hideHoverMenu()"
          >
            <a
              [routerLink]="ROUTES.HOME"
              aria-label="Home"
              aria-haspopup="true"
              [attr.aria-expanded]="hoverMenuId() === 'home'"
              (focus)="showHoverMenu('home', $event.currentTarget)"
            >
              <i
                class="fa-sharp fa-solid fa-house fa-icon fa-2x"
                [routerLinkActive]="['navbar__link-active']"
                aria-hidden="true"
              ></i>
            </a>
          </div>
          @if (hoverMenuId() === 'home') {
            <div
              class="navbar__filing-menu navbar__filing-menu--floating"
              [style.left.px]="hoverMenuPosition().left"
              [style.top.px]="hoverMenuPosition().top"
              (mouseenter)="cancelHideHoverMenu()"
              (mouseleave)="hideHoverMenu()"
            >
              <ul>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="ROUTES.HOME"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >Home</a
                  >
                </li>
              </ul>
            </div>
          }
        </li>

        <!-- eBinder hidden per bug #172433
    <li class="navbar__link">
      <div
        class="navbar__filing-trigger"
        (mouseenter)="showHoverMenu('eBinder', $event.currentTarget)"
        (mouseleave)="hideHoverMenu()"
      >
        <i
          class="fa-sharp fa-solid fa-folder-open fa-icon fa-2x"
          [routerLink]="ROUTES.TRIALBINDER"
          [routerLinkActive]="['navbar__link-active']"
          (click)="resetTrialBinders()"
        ></i>
      </div>
      @if (hoverMenuId() === 'eBinder') {
        <div
          class="navbar__filing-menu navbar__filing-menu--floating"
          [style.left.px]="hoverMenuPosition().left"
          [style.top.px]="hoverMenuPosition().top"
          (mouseenter)="cancelHideHoverMenu()"
          (mouseleave)="hideHoverMenu()"
        >
          <a
            class="navbar__filing-menu-link"
            [routerLink]="ROUTES.TRIALBINDER"
            routerLinkActive="navbar__filing-menu-link-active"
            (click)="resetTrialBinders()"
            >eBinder</a
          >
        </div>
      }
    </li>
    -->

        <li
          class="navbar__link navbar__filing-wrapper"
          (focusout)="onFilingGroupFocusOut($event)"
          (keydown.escape)="onFilingGroupEscape()"
          tabindex="-1"
        >
          <div
            #filingTrigger
            class="navbar__filing-trigger"
            (mouseenter)="showFilingMenu()"
            (mouseleave)="hideFilingMenu()"
          >
            <a
              [routerLink]="ROUTES.FILING"
              [routerLinkActive]="['navbar__link-active']"
              aria-label="eFiling"
              aria-haspopup="true"
              [attr.aria-expanded]="filingMenuVisible()"
              (focus)="showFilingMenu()"
            >
              <i
                class="fa-sharp fa-solid fa-files fa-icon fa-2x"
                [class.navbar__link-active]="isFilingRouteActive"
                aria-hidden="true"
              ></i>
            </a>
          </div>
          @if (filingMenuVisible()) {
            <div
              class="navbar__filing-menu navbar__filing-menu--floating"
              [style.left.px]="filingMenuPosition().left"
              [style.top.px]="filingMenuPosition().top"
              (mouseenter)="cancelHideFilingMenu()"
              (mouseleave)="hideFilingMenu()"
            >
              <ul>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="['/', ROUTES.FILING, FILING_ROUTES.NEW_CASE]"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >New Case eFiling</a
                  >
                </li>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    routerLinkActive="navbar__filing-menu-link-active"
                    [routerLink]="[
                      '/',
                      ROUTES.FILING,
                      FILING_ROUTES.EXISTING_CASE,
                    ]"
                    >Existing Case eFiling</a
                  >
                </li>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    routerLinkActive="navbar__filing-menu-link-active"
                    [routerLink]="[
                      '/',
                      ROUTES.FILING,
                      FILING_ROUTES.MULTI_CASE,
                    ]"
                    >Multi-Case eFiling</a
                  >
                </li>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    routerLinkActive="navbar__filing-menu-link-active"
                    [routerLink]="[
                      '/',
                      ROUTES.FILING,
                      FILING_ROUTES.SAVED_TRANSACTIONS,
                    ]"
                    >Saved Draft Transactions</a
                  >
                </li>
              </ul>
            </div>
          }
        </li>

        <li
          class="navbar__link"
          (focusout)="onHoverGroupFocusOut($event)"
          (keydown.escape)="onHoverGroupEscape($event)"
          tabindex="-1"
        >
          <div
            class="navbar__filing-trigger"
            (mouseenter)="showHoverMenu('mailbox', $event.currentTarget)"
            (mouseleave)="hideHoverMenu()"
          >
            <a
              [routerLink]="ROUTES.MAILBOX"
              aria-label="Mailbox"
              aria-haspopup="true"
              [attr.aria-expanded]="hoverMenuId() === 'mailbox'"
              (focus)="showHoverMenu('mailbox', $event.currentTarget)"
            >
              <i
                class="fa-sharp fa-solid fa-envelope fa-icon fa-2x"
                [routerLinkActive]="['navbar__link-active']"
                aria-hidden="true"
              ></i>
            </a>
          </div>
          @if (hoverMenuId() === 'mailbox') {
            <div
              class="navbar__filing-menu navbar__filing-menu--floating"
              [style.left.px]="hoverMenuPosition().left"
              [style.top.px]="hoverMenuPosition().top"
              (mouseenter)="cancelHideHoverMenu()"
              (mouseleave)="hideHoverMenu()"
            >
              <ul>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="[ROUTES.MAILBOX, MAILBOX_TAB.INBOX]"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >Inbox</a
                  >
                </li>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="[ROUTES.MAILBOX, MAILBOX_TAB.SENT]"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >Sent Items</a
                  >
                </li>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="[ROUTES.MAILBOX, MAILBOX_TAB.REJECTED]"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >Rejected Items</a
                  >
                </li>
              </ul>
            </div>
          }
        </li>

        @if (canAccessClerkReview) {
          <li
            class="navbar__link"
            (focusout)="onHoverGroupFocusOut($event)"
            (keydown.escape)="onHoverGroupEscape($event)"
            tabindex="-1"
          >
            <div
              class="navbar__filing-trigger"
              (mouseenter)="
                showHoverMenu('clerkReviewList', $event.currentTarget)
              "
              (mouseleave)="hideHoverMenu()"
            >
              <a
                [routerLink]="ROUTES.CLERK_REVIEW_LIST"
                aria-label="Clerk Review"
                aria-haspopup="true"
                [attr.aria-expanded]="hoverMenuId() === 'clerkReviewList'"
                (focus)="showHoverMenu('clerkReviewList', $event.currentTarget)"
              >
                <i
                  class="fa-sharp fa-solid fa-stamp fa-icon fa-2x"
                  [routerLinkActive]="['navbar__link-active']"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            @if (hoverMenuId() === 'clerkReviewList') {
              <div
                class="navbar__filing-menu navbar__filing-menu--floating"
                [style.left.px]="hoverMenuPosition().left"
                [style.top.px]="hoverMenuPosition().top"
                (mouseenter)="cancelHideHoverMenu()"
                (mouseleave)="hideHoverMenu()"
              >
                <ul>
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [routerLink]="ROUTES.CLERK_REVIEW_LIST"
                      routerLinkActive="navbar__filing-menu-link-active"
                      >Clerk Review</a
                    >
                  </li>
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [routerLink]="ROUTES.BATCH_REVIEW_LIST"
                      routerLinkActive="navbar__filing-menu-link-active"
                      >Batches for Clerk Review</a
                    >
                  </li>
                </ul>
              </div>
            }
          </li>
        }

        @if (canAccessJudgeReview) {
          <li
            class="navbar__link"
            (focusout)="onHoverGroupFocusOut($event)"
            (keydown.escape)="onHoverGroupEscape($event)"
            tabindex="-1"
          >
            <div
              class="navbar__filing-trigger"
              (mouseenter)="
                showHoverMenu('judgeReviewList', $event.currentTarget)
              "
              (mouseleave)="hideHoverMenu()"
            >
              <a
                [routerLink]="judgeReviewRoute"
                aria-label="Judge Review"
                aria-haspopup="true"
                [attr.aria-expanded]="hoverMenuId() === 'judgeReviewList'"
                (focus)="showHoverMenu('judgeReviewList', $event.currentTarget)"
              >
                <i
                  class="fa-sharp fa-solid fa-gavel fa-icon fa-2x"
                  [routerLinkActive]="['navbar__link-active']"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            @if (hoverMenuId() === 'judgeReviewList') {
              <div
                class="navbar__filing-menu navbar__filing-menu--floating"
                [style.left.px]="hoverMenuPosition().left"
                [style.top.px]="hoverMenuPosition().top"
                (mouseenter)="cancelHideHoverMenu()"
                (mouseleave)="hideHoverMenu()"
              >
                <ul>
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [routerLink]="judgeReviewRoute"
                      routerLinkActive="navbar__filing-menu-link-active"
                      >Judge Review</a
                    >
                  </li>
                </ul>
              </div>
            }
          </li>
        }

        @if (canAccessMessageBoard) {
          <li
            class="navbar__link"
            (focusout)="onHoverGroupFocusOut($event)"
            (keydown.escape)="onHoverGroupEscape($event)"
            tabindex="-1"
          >
            <div
              class="navbar__filing-trigger"
              (mouseenter)="showHoverMenu('messageBoard', $event.currentTarget)"
              (mouseleave)="hideHoverMenu()"
            >
              <a
                [routerLink]="ROUTES.MESSAGEBOARD"
                aria-label="Message Board"
                aria-haspopup="true"
                [attr.aria-expanded]="hoverMenuId() === 'messageBoard'"
                (focus)="showHoverMenu('messageBoard', $event.currentTarget)"
                (click)="resetTrialBinders()"
              >
                <i
                  class="fa-sharp fa-solid fa-message-lines fa-icon fa-2x"
                  [routerLinkActive]="['navbar__link-active']"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            @if (hoverMenuId() === 'messageBoard') {
              <div
                class="navbar__filing-menu navbar__filing-menu--floating"
                [style.left.px]="hoverMenuPosition().left"
                [style.top.px]="hoverMenuPosition().top"
                (mouseenter)="cancelHideHoverMenu()"
                (mouseleave)="hideHoverMenu()"
              >
                <ul>
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [routerLink]="ROUTES.MESSAGEBOARD"
                      routerLinkActive="navbar__filing-menu-link-active"
                      >Message Board</a
                    >
                  </li>
                </ul>
              </div>
            }
          </li>
        }

        @if (canModifyOrg && isLawFirmUser) {
          <li
            class="navbar__link"
            (focusout)="onHoverGroupFocusOut($event)"
            (keydown.escape)="onHoverGroupEscape($event)"
            tabindex="-1"
          >
            <div
              class="navbar__filing-trigger"
              (mouseenter)="showHoverMenu('orgSettings', $event.currentTarget)"
              (mouseleave)="hideHoverMenu()"
            >
              <a
                [class.fa-stack]="!isAccountSettingsUser()"
                [routerLink]="ROUTES.PREFERENCES"
                [routerLinkActive]="['navbar__link-active']"
                ariaCurrentWhenActive="page"
                [attr.aria-label]="orgSettingsLabel()"
                aria-haspopup="true"
                [attr.aria-expanded]="hoverMenuId() === 'orgSettings'"
                (focus)="showHoverMenu('orgSettings', $event.currentTarget)"
              >
                @if (isAccountSettingsUser()) {
                  <!-- Single glyph: active bar on the icon, like the other single-icon links. -->
                  <i
                    class="fa-solid fa-user-gear fa-icon fa-2x"
                    [routerLinkActive]="['navbar__link-active']"
                    aria-hidden="true"
                  ></i>
                } @else {
                  <i
                    class="fa-sharp fa-icon fa-solid fa-buildings fa-stack-2x"
                    aria-hidden="true"
                  ></i>
                  <i
                    class="fa-sharp fa-icon fa-solid fa-gear fa-stack-1x fa-sub"
                    aria-hidden="true"
                  ></i>
                }
              </a>
            </div>
            @if (hoverMenuId() === 'orgSettings') {
              <div
                class="navbar__filing-menu navbar__filing-menu--floating"
                [style.left.px]="hoverMenuPosition().left"
                [style.top.px]="hoverMenuPosition().top"
                (mouseenter)="cancelHideHoverMenu()"
                (mouseleave)="hideHoverMenu()"
              >
                <ul>
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [routerLink]="ROUTES.PREFERENCES"
                      routerLinkActive="navbar__filing-menu-link-active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      >{{ orgSettingsLabel() }}</a
                    >
                  </li>
                </ul>
              </div>
            }
          </li>
        }

        @if (canModifyOrg && isCourtUser) {
          <li
            class="navbar__link"
            (focusout)="onHoverGroupFocusOut($event)"
            (keydown.escape)="onHoverGroupEscape($event)"
            tabindex="-1"
          >
            <div
              class="navbar__filing-trigger"
              (mouseenter)="
                showHoverMenu('courtSettings', $event.currentTarget)
              "
              (mouseleave)="hideHoverMenu()"
            >
              <a
                class="fa-stack"
                [routerLink]="ROUTES.PREFERENCES"
                [routerLinkActive]="['navbar__link-active']"
                ariaCurrentWhenActive="page"
                aria-label="Court Settings"
                aria-haspopup="true"
                [attr.aria-expanded]="hoverMenuId() === 'courtSettings'"
                (focus)="showHoverMenu('courtSettings', $event.currentTarget)"
              >
                <i
                  class="fa-sharp fa-icon fa-solid fa-building-columns fa-stack-2x"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa-sharp fa-icon fa-solid fa-gear fa-stack-1x fa-sub"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            @if (hoverMenuId() === 'courtSettings') {
              <div
                class="navbar__filing-menu navbar__filing-menu--floating"
                [style.left.px]="hoverMenuPosition().left"
                [style.top.px]="hoverMenuPosition().top"
                (mouseenter)="cancelHideHoverMenu()"
                (mouseleave)="hideHoverMenu()"
              >
                <ul>
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [routerLink]="ROUTES.PREFERENCES"
                      routerLinkActive="navbar__filing-menu-link-active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      >Manage Court Settings</a
                    >
                  </li>
                </ul>
              </div>
            }
          </li>
        }

        <li class="navbar__divider" aria-hidden="true"></li>

        <!-- Search (opens Classic File & ServeXpress) -->
        <li
          class="navbar__link"
          (focusout)="onHoverGroupFocusOut($event)"
          (keydown.escape)="onHoverGroupEscape($event)"
          tabindex="-1"
        >
          <div
            class="navbar__filing-trigger"
            (mouseenter)="showHoverMenu('classicSearch', $event.currentTarget)"
            (mouseleave)="hideHoverMenu()"
          >
            <a
              class="navbar__classic-link"
              [href]="classicUrl(classicSearchLinks[0].path)"
              target="_blank"
              rel="noopener"
              aria-label="Search — opens Classic File &amp; ServeXpress"
              aria-haspopup="true"
              [attr.aria-expanded]="hoverMenuId() === 'classicSearch'"
              (focus)="showHoverMenu('classicSearch', $event.currentTarget)"
            >
              <i
                class="fa-sharp fa-solid fa-magnifying-glass fa-icon fa-2x"
                aria-hidden="true"
              ></i>
              <span class="navbar__classic-label">Classic</span>
            </a>
          </div>
          @if (hoverMenuId() === 'classicSearch') {
            <div
              class="navbar__filing-menu navbar__filing-menu--floating"
              [style.left.px]="hoverMenuPosition().left"
              [style.top.px]="hoverMenuPosition().top"
              (mouseenter)="cancelHideHoverMenu()"
              (mouseleave)="hideHoverMenu()"
            >
              <ul>
                @for (link of classicSearchLinks; track link.path) {
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [href]="classicUrl(link.path)"
                      target="_blank"
                      rel="noopener"
                      >{{ link.label }}</a
                    >
                  </li>
                }
              </ul>
            </div>
          }
        </li>

        <!-- Alerts (opens Classic File & ServeXpress) -->
        <li
          class="navbar__link"
          (focusout)="onHoverGroupFocusOut($event)"
          (keydown.escape)="onHoverGroupEscape($event)"
          tabindex="-1"
        >
          <div
            class="navbar__filing-trigger"
            (mouseenter)="showHoverMenu('classicAlerts', $event.currentTarget)"
            (mouseleave)="hideHoverMenu()"
          >
            <a
              class="navbar__classic-link"
              [href]="classicUrl(classicAlertsPath)"
              target="_blank"
              rel="noopener"
              aria-label="Alerts — opens Classic File &amp; ServeXpress"
              aria-haspopup="true"
              [attr.aria-expanded]="hoverMenuId() === 'classicAlerts'"
              (focus)="showHoverMenu('classicAlerts', $event.currentTarget)"
            >
              <span class="navbar__classic-icon-wrap">
                <i
                  class="fa-sharp fa-solid fa-bell fa-icon fa-2x"
                  aria-hidden="true"
                ></i>
                <span class="navbar__alert-dot" aria-hidden="true"></span>
              </span>
              <span class="navbar__classic-label">Classic</span>
            </a>
          </div>
          @if (hoverMenuId() === 'classicAlerts') {
            <div
              class="navbar__filing-menu navbar__filing-menu--floating"
              [style.left.px]="hoverMenuPosition().left"
              [style.top.px]="hoverMenuPosition().top"
              (mouseenter)="cancelHideHoverMenu()"
              (mouseleave)="hideHoverMenu()"
            >
              <ul>
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [href]="classicUrl(classicAlertsPath)"
                    target="_blank"
                    rel="noopener"
                    >Alerts</a
                  >
                </li>
              </ul>
            </div>
          }
        </li>

        <!-- My Filings (opens Classic File & ServeXpress) -->
        <li
          class="navbar__link"
          (focusout)="onHoverGroupFocusOut($event)"
          (keydown.escape)="onHoverGroupEscape($event)"
          tabindex="-1"
        >
          <div
            class="navbar__filing-trigger"
            (mouseenter)="showHoverMenu('classicFilings', $event.currentTarget)"
            (mouseleave)="hideHoverMenu()"
          >
            <a
              class="navbar__classic-link"
              [href]="classicUrl(classicInboxPath)"
              target="_blank"
              rel="noopener"
              aria-label="My Filings — opens Classic File &amp; ServeXpress"
              aria-haspopup="true"
              [attr.aria-expanded]="hoverMenuId() === 'classicFilings'"
              (focus)="showHoverMenu('classicFilings', $event.currentTarget)"
            >
              <i
                class="fa-sharp fa-solid fa-inbox fa-icon fa-2x"
                aria-hidden="true"
              ></i>
              <span class="navbar__classic-label">Classic</span>
            </a>
          </div>
          @if (hoverMenuId() === 'classicFilings') {
            <div
              class="navbar__filing-menu navbar__filing-menu--floating"
              [style.left.px]="hoverMenuPosition().left"
              [style.top.px]="hoverMenuPosition().top"
              (mouseenter)="cancelHideHoverMenu()"
              (mouseleave)="hideHoverMenu()"
            >
              <ul>
                @for (link of classicFilingsLinks; track link.path) {
                  <li>
                    <a
                      class="navbar__filing-menu-link"
                      [href]="classicUrl(link.path)"
                      target="_blank"
                      rel="noopener"
                      >{{ link.label }}</a
                    >
                  </li>
                }
              </ul>
            </div>
          }
        </li>
      </ul>
    </div>
    @if (canScrollDown()) {
      <button
        type="button"
        class="navbar__scroll-btn navbar__scroll-btn--down"
        aria-label="Scroll navigation down"
        (click)="scrollNav(1)"
      >
        <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
      </button>
    }
  </div>
  <section class="bottom-links">
    @if ((isInternalUser || canEmulate) && !loadingUser) {
      <span
        class="navbar__link"
        (focusout)="onHoverGroupFocusOut($event)"
        (keydown.escape)="onHoverGroupEscape($event)"
        tabindex="-1"
      >
        <div
          class="navbar__filing-trigger"
          (mouseenter)="showHoverMenu('systemAdmin', $event.currentTarget)"
          (mouseleave)="hideHoverMenu()"
        >
          <a
            [routerLink]="isInternalUser ? ROUTES.SYSTEM_ADMIN : ROUTES.EMULATE"
            routerLinkActive="navbar__link-active"
            aria-label="System Administration"
            aria-haspopup="true"
            [attr.aria-expanded]="hoverMenuId() === 'systemAdmin'"
            (focus)="showHoverMenu('systemAdmin', $event.currentTarget)"
          >
            <i
              [routerLinkActive]="['fa-regular']"
              class="fa-sharp fa-solid fa-gear fa-icon fa-2x"
              aria-hidden="true"
            ></i>
          </a>
        </div>
        @if (hoverMenuId() === 'systemAdmin') {
          <div
            class="navbar__filing-menu navbar__filing-menu--floating"
            [style.left.px]="hoverMenuPosition().left"
            [style.top.px]="hoverMenuPosition().top"
            (mouseenter)="cancelHideHoverMenu()"
            (mouseleave)="hideHoverMenu()"
          >
            <ul>
              @if (isInternalUser) {
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="ROUTES.SYSTEM_ADMIN"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >System Administration</a
                  >
                </li>
              }
              @if (canEmulate) {
                <li>
                  <a
                    class="navbar__filing-menu-link"
                    [routerLink]="ROUTES.EMULATE"
                    routerLinkActive="navbar__filing-menu-link-active"
                    >Emulate a User</a
                  >
                </li>
              }
            </ul>
          </div>
        }
      </span>
    }

    @if (!isInternalUser && !loadingUser) {
      <span
        class="navbar__link"
        (focusout)="onHoverGroupFocusOut($event)"
        (keydown.escape)="onHoverGroupEscape($event)"
        tabindex="-1"
      >
        <div
          class="navbar__filing-trigger"
          (mouseenter)="showHoverMenu('contact', $event.currentTarget)"
          (mouseleave)="hideHoverMenu()"
          role="button"
          aria-label="Contact Us"
          aria-haspopup="true"
          [attr.aria-expanded]="hoverMenuId() === 'contact'"
          (focus)="showHoverMenu('contact', $event.currentTarget)"
          tabindex="0"
        >
          <i
            class="fa-icon fa-sharp fa-solid fa-address-book fa-2x"
            aria-hidden="true"
          ></i>
        </div>
        @if (hoverMenuId() === 'contact') {
          <div
            class="navbar__filing-menu navbar__filing-menu--floating"
            [style.left.px]="hoverMenuPosition().left"
            [style.top.px]="hoverMenuPosition().top"
            (mouseenter)="cancelHideHoverMenu()"
            (mouseleave)="hideHoverMenu()"
          >
            <ul>
              <li>
                <a
                  class="navbar__filing-menu-link"
                  id="LnkChatOnline"
                  href="javascript:void zE('messenger', 'open');"
                  aria-label="Chat Online"
                  >Chat Online</a
                >
              </li>
              <li>
                <a
                  class="navbar__filing-menu-link"
                  href="tel:1-888-529-7587"
                  aria-label="Call 1-888-529-7587"
                  >1-888-529-7587</a
                >
              </li>
            </ul>
          </div>
        }
      </span>
    }
    <a
      class="navbar--logo"
      [routerLink]="ROUTES.HOME"
      aria-label="File and ServeXpress Home"
    >
      <img
        class="navbar__logo-img"
        alt="File and ServeXpress logo"
        src="../../../assets/icons/FSX-logo.png"
      />
    </a>
  </section>
</nav>
